


































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* module */
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { routerPath, errorFlag } from '@/app/model/store/domain/const'
/* api */
import stageUpdateApi from '@/app/model/api/stageUpdateApi'
import VarietyGrowthDetailApi from '@/app/model/api/varietyGrowthDetailApi'
import graphApi from '@/app/model/api/graphApi'
import CommonClass from '@/app/module/common'

@Component
export default class StageUpdateModal extends Vue {
  @Prop() private varietyGrowthId!: string
  @Prop() private createCopy!: boolean

  @Watch('createCopy')
  createVarietyCopy (flag: boolean) {
    if (flag) {
      // 品種生育登録画面でコピーを作成
      Session.setCopyVarietyGrowthData(JSON.stringify(this.varietyGrowthData))
      this.$router.push('/master/variety-growth/create').catch(e => {})
    }
  }

  private stageData: {[key: string]: number|string|any} = {}
  private defaultDate: string = '-年-月-日'
  private masterDate: string = '-年-月-日'
  private variableDay: string = ''
  private defaultDay: string = ''
  private changeId: number = 0
  private errorMessage: string = ''
  private growthStageListData: any = {}
  private stemNumType: string = '1'

  /* computed */
  private get stageUpdatedId (): number {
    return this.$store.state.stageUpdateState.changeStageId
  }
  private get graphActualDataFlag () {
    return this.$store.state.setFlagState.graphActualDataFlag
  }
  private get graphMasterDataFlag () {
    return this.$store.state.setFlagState.graphMasterDataFlag
  }

  @Watch('stageUpdatedId')
  onChangeId (val: any) {
    this.createListData()
  }
  @Watch('graphActualDataFlag')
  onChangeActualFlag (flag: string) {
    if (flag && this.$store.state.setFlagState.graphMasterDataFlag) {
      this.createListData()
      this.$store.commit('setFlagState/setGraphMasterDataFlag', false)
      this.$store.commit('setFlagState/setGraphActualDataFlag', false)
    }
  }
  @Watch('graphMasterDataFlag')
  onChangeMasterFlag (flag: string) {
    if (flag && this.$store.state.setFlagState.graphActualDataFlag) {
      this.createListData()
      this.$store.commit('setFlagState/setGraphMasterDataFlag', false)
      this.$store.commit('setFlagState/setGraphActualDataFlag', false)
    }
  }

  created () {
    this.createListData()
  }

  private beforeStageDateSpan (key: number) {
    if (key === 0) {
      return '-'
    } else {
      const spanDate = this.growthStageListData[key].elapsed_days - this.growthStageListData[key - 1].elapsed_days
      return spanDate + '日'
    }
  }

  private changeStageDateBg (val: any[]) {
    if (val === undefined || val.length === 0) {
      return '#FFF'
    } else {
      return 'rgba(247,215,30,0.7)'
    }
  }

  private displayValue (val: number, text: string) {
    if (val !== null && val !== undefined) {
      return text !== '' && text !== undefined ? val + text : val
    }
    return ''
  }

  private createListData () {
    if (Session.getPlantingDay()! === null) {
      return
    }

    this.growthStageListData = JSON.parse(Session.getGrowthStage()!)
    const plantingData = JSON.parse(Session.getGraphData()!)
    const predictionData = JSON.parse(Session.getPredictionData()!)
    const masterData = JSON.parse(Session.getMasterData()!)
    const graphLastDay = Session.getGraphLastDay()!
    const plantingDate = DateClass.formingDate(Session.getPlantingDay()!)
    this.stemNumType = Session.getStemNumberType()!
    let actualData: any[] = []
    let actualStartDate: string = ''

    // 実績データのObjectを → 配列変換
    if (plantingData !== null) {
      actualData = Object.entries(plantingData).map(([recordDate, data]) => ({ recordDate, data }))
    }

    for (let i in this.growthStageListData) {
      actualStartDate = ''
      let count = 0
      if (parseInt(i) !== (this.growthStageListData.length - 1)) {
        let nextStageDate = DateClass.formingDate(Object.keys(predictionData)[ parseInt(i) + 1 ])
        // 次のステージ-1日のデータをセット
        actualStartDate = this.convertDate(new Date(nextStageDate.setDate(nextStageDate.getDate() - 1)))
      }
      for (let j in predictionData) {
        if (this.growthStageListData[i].elapsed_days === predictionData[j].elapsed_days) {
          let newDate = new Date(plantingDate.getTime() + (predictionData[j].elapsed_days * 24 * 60 * 60 * 1000))
          let keyDate = this.convertDate(newDate)
          if (graphLastDay === '' || parseInt(keyDate) > parseInt(graphLastDay)) {
            this.growthStageListData[i].showPrediction = true
            this.growthStageListData[i].integration_temperature = predictionData[j].integration_temperature
          } else {
            this.growthStageListData[i].showPrediction = false
            // 積算温度セット
            if (plantingData === null || plantingData[j] === undefined) {
              this.growthStageListData[i].integration_temperature = null
            } else {
              this.growthStageListData[i].integration_temperature = plantingData[j].integration_temperature
            }
            // element1セット
            if (actualData.length !== 0) {
              // 現ステージから次ステージの1日前までで一番直近の値を抽出(undefinedまたはnulデータは除外)
              this.getMostRecentData(actualData, actualStartDate, i, j, 'element1')
              this.getMostRecentData(actualData, actualStartDate, i, j, 'element2')
              this.getMostRecentData(actualData, actualStartDate, i, j, 'element3')
              this.getMostRecentData(actualData, actualStartDate, i, j, 'element4')
              this.getMostRecentData(actualData, actualStartDate, i, j, 'soil_ec')
              this.getMostRecentData(actualData, actualStartDate, i, j, 'ground_temp')
            }
          }
          this.defaultDate = keyDate.slice(0, 4) + '年' + keyDate.slice(4, 6) + '月' + keyDate.slice(6, 8) + '日'
          this.growthStageListData[i].date = this.defaultDate
        }
      }
      for (var k in masterData) {
        if (parseInt(i) === count) {
          this.growthStageListData[i].masterDate = k.slice(0, 4) + '年' + k.slice(4, 6) + '月' + k.slice(6, 8) + '日'
          this.growthStageListData[i].goal_elapsed_days = masterData[k].goal_elapsed_days
          this.growthStageListData[i].goal_spad = masterData[k].goal_spad
          this.growthStageListData[i].goal_stem_number = masterData[k].goal_stem_number
          this.growthStageListData[i].goal_stem_number_m2 = masterData[k].goal_stem_number_m2
          this.growthStageListData[i].goal_growth_height = masterData[k].goal_growth_height
          this.growthStageListData[i].goal_integration_temperature = masterData[k].goal_integration_temperature
        }
        count++
      }
    }
  }

  private getMostRecentData (actualData: any, actualStartDate: any, stageNum: string, predictionKye: string, key: string) {
    let data
    if (actualStartDate === '') {
      data = actualData.filter((val :any, index :any, arr: any[]) => {
        if ((val.recordDate >= predictionKye) && val.data[key] !== undefined && val.data[key] !== null) {
          return true
        }
      })
    } else {
      data = actualData.filter((val :any, index :any, arr: any[]) => {
        if ((actualStartDate >= val.recordDate) && (val.recordDate >= predictionKye) && val.data[key] !== undefined && val.data[key] !== null) {
          return true
        }
      })
    }
    if (data.length !== 0) {
      // 抽出した配列の最新のデータをセット(対象ステージ日以降の直近のデータをセットするため)
      this.growthStageListData[stageNum][key] = data[0].data[key]
    } else {
      this.growthStageListData[stageNum][key] = null
    }
  }

  private getVarietyGrowthDetail () {
    (async () => {
      const result = await VarietyGrowthDetailApi.getVarietyGrowthDetail(this.varietyGrowthId)
      if (result.isOk()) {
        this.varietyGrowthData = result.getPayload()
        this.createVarietyGrowth()
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private varietyGrowthData: any

  private createVarietyGrowth () {
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let countPlant = 0
    let lastStageNum: number = 0
    // ステージまで実績ある物のみ実績値をセット
    for (let i in this.varietyGrowthData.variety_growth_stages) {
      for (let j in this.growthStageListData) {
        if (!this.growthStageListData[j].showPrediction && this.growthStageListData[j].growth_step === this.varietyGrowthData.variety_growth_stages[i].step) {
          this.varietyGrowthData.variety_growth_stages[i].integrated_temp = this.growthStageListData[j].integration_temperature
          this.varietyGrowthData.variety_growth_stages[i].spad = this.growthStageListData[j].spad
          this.varietyGrowthData.variety_growth_stages[i].stem_number = this.growthStageListData[j].stem_number
          this.varietyGrowthData.variety_growth_stages[i].stem_number_m2 = this.growthStageListData[j].stem_number_m2
          this.varietyGrowthData.variety_growth_stages[i].growth_height = this.growthStageListData[j].growth_height
          this.varietyGrowthData.variety_growth_stages[i].ph = this.growthStageListData[j].ph
          this.varietyGrowthData.variety_growth_stages[i].water_temp = this.growthStageListData[j].water_temp
          this.varietyGrowthData.variety_growth_stages[i].ground_temp = this.growthStageListData[j].ground_temp
          countPlant++
          lastStageNum = parseInt(j)
        }
      }
    }
    if (countPlant === this.growthStageListData.length) {
      // 品種生育登録画面でコピーを作成
      Session.setCopyVarietyGrowthData(JSON.stringify(this.varietyGrowthData))
      this.$router.push('/master/variety-growth/create').catch(e => {})
    } else if (countPlant === 0) {
      this.$emit('show-confirm-modal', '')
    } else {
      this.$emit('show-confirm-modal', this.growthStageListData[lastStageNum + 1].growth_stage_name)
    }
  }

  private closeModal () {
    this.errorMessage = ''
    this.variableDay = this.defaultDay
    this.$emit('close-stage-list-modal')
  }

  private convertDate (date: Date) {
    return '' + date.getFullYear() + DateClass.toDoubleDigits(date.getMonth() + 1) + DateClass.toDoubleDigits(date.getDate())
  }
}
